import styled from '@emotion/styled';
// eslint-disable-next-line custom-rules/no-mui-material-button
import { Button } from '@mui/material';
import { To } from 'react-router-dom';

import { theme } from '@/theme';

import { BUTTON_TEXT_TYPES, ButtonColors, ButtonSize, ButtonTextType, ButtonType, ButtonWidth } from './Button.consts';

//

const isTextType = (type: ButtonType): type is ButtonTextType => BUTTON_TEXT_TYPES.includes(type as ButtonTextType);

export const ButtonStyled = styled(Button)<{
    href?: To;
    buttonsize: ButtonSize;
    buttonwidth: ButtonWidth;
    buttontype: ButtonType;
    buttoncolors: ButtonColors;
}>`
    display: ${(href) => (href ? 'inline-flex' : 'flex')};
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    gap: 0.677rem;
    overflow: hidden;
    border-radius: 0.5rem;
    max-height: 3.4rem;

    border-width: 1px;
    border-style: solid;

    ${({ buttonsize, buttonwidth }) => {
        if (buttonsize === 'small-x')
            return buttonwidth === 'default'
                ? { padding: '0.5rem 1rem', minHeight: '0', minWidth: '0', lineHeight: '1.5' }
                : { padding: '3px 3px 2px', minHeight: 'initial', minWidth: 'initial', lineHeight: '1.5' };
        if (buttonsize === 'small')
            return buttonwidth === 'default'
                ? { padding: '0.4rem .9rem', minHeight: '0', minWidth: '0' }
                : { padding: '2px 3px 3px', minHeight: 'initial', minWidth: 'initial' };

        // NOTE: buttonsize === 'normal'
        return buttonwidth === 'default'
            ? { padding: '0.5rem 1.2rem', minHeight: '3.4rem', minWidth: '10.3rem' }
            : { padding: '2px 3px 3px', minHeight: 'initial', minWidth: 'initial' };
    }}

    ${({ buttontype, buttoncolors }) => {
        return {
            ...buttoncolors,
            '&.Mui-disabled': {
                backgroundColor: isTextType(buttontype) ? 'transparent' : theme.palette.background.disabled,
                borderColor: isTextType(buttontype) ? 'transparent' : theme.palette.background.disabled,
                color: '#828282',
                svg: { color: '#828282' },
            },
        };
    }}
`;

export const StyledButtonTitle = styled('span')<{ size: ButtonSize }>`
    text-transform: initial;
    white-space: nowrap;

    ${({ size }) => {
        if (size === 'small-x') return { fontSize: '0.677em', fontWeight: '600', letterSpacing: '0.097rem' };
        if (size === 'small') return { fontSize: '0.877em', fontWeight: '500', letterSpacing: '0.0333rem' };

        // NOTE: buttonsize === 'normal'
        return { fontSize: '1em' };
    }}
`;
